export default "__VITE_ASSET__9KGL444R__"